// src/services/apiConfig.js
// Central place to define backend API base URL

const API_BASE_URL = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL) ? process.env.REACT_APP_API_URL : 'https://api.price-perfect.com';

//for local testing use http://localhost:3800
//const API_BASE_URL = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL) ? process.env.REACT_APP_API_URL : 'http://localhost:3800';


export default API_BASE_URL;
